import { render, staticRenderFns } from "./DirectoryDelete.vue?vue&type=template&id=045ad743&"
import script from "./DirectoryDelete.vue?vue&type=script&lang=js&"
export * from "./DirectoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports